import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

export interface RegistrationApi {
  id: number;
  userId: number;
  courseId: number;
  courseName: string;
  studentFirstName: string;
  studentSurname: string;
  studentEmail: string;
  fullyPaid: boolean;
  isInvoice: boolean;
  createdDate: Date;
  updatedDate?: Date;
}

export interface RegistrationApplicationFormField {
  courseFormFieldId: number;
  description: string;
  dictionaryId: number | null;
  isEditable: boolean;
  isRequired: boolean;
  name: string;
  registrationFieldValueId: number;
  type: number;
  value: string;
}

export interface RegistrationApplicationForm {
  createdDate: Date;
  registrationId: number;
  groups: {
    courseFormGroupId: number;
    name: string;
    description: string;
    fields: RegistrationApplicationFormField[];
  }[];
}

const getRegistrations = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string,
  orderBy?: string,
): AxiosPromise<{ data: RegistrationApi[]; total: number }> => {
  return api.get(endpoints.REGISTRATIONS.GET(skip, take, searchPhrase, filter, orderBy));
};

const getRegistrationsByCourse = (courseId: number): AxiosPromise<RegistrationApi[]> => {
  return api.get(endpoints.REGISTRATIONS.GET_BY_COURSE(courseId));
};

const getApplicationForm = (studentId: number, courseId: number): AxiosPromise<RegistrationApplicationForm> => {
  return api.get(endpoints.REGISTRATIONS.GET_APPLICATION_FORM(studentId, courseId));
};

const updateField = (studentId: number, courseId: number, fieldId: number, body: { value: string }): AxiosPromise => {
  return api.put(endpoints.REGISTRATIONS.UPDATE_FIELD(studentId, courseId, fieldId), body);
};

const updateForm = (
  studentId: number,
  courseId: number,
  body: { fields: { fieldId: number; value: string }[] },
): AxiosPromise => {
  return api.put(endpoints.REGISTRATIONS.UPDATE_FORM(studentId, courseId), body);
};

export const registrationsApi = {
  getRegistrations,
  getRegistrationsByCourse,
  getApplicationForm,
  updateField,
  updateForm,
};
